// extracted by mini-css-extract-plugin
export default {"PageContainer":"PageContainer_PageContainer__xreuy","wrapper":"PageContainer_wrapper__9xU40"};